var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatCardVideoCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 7.9c-.1-.4-.3-.7-.6-.7-.5-.1-1.2-.2-2.4-.2-1.4 0-2 .1-2.4.2-.4.1-.6.3-.7.7 0 .5-.1 1.2-.1 2.1 0 .9.1 1.6.1 2.1.1.4.3.7.6.7.6.1 1.2.2 2.5.2s1.9-.1 2.4-.2c.3-.1.6-.4.6-.7.1-.5.1-1.1.1-2.1 0-.9 0-1.6-.1-2.1zm2.1-.2c-.6 0-1.3 1.1-1.3 1.7v1.3c0 .7.7 1.7 1.3 1.7.3 0 .3-1.3.3-2.3s.1-2.4-.3-2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatCardVideoCall);
export default __webpack_public_path__ + "static/media/icon_chat_card_video_call.4c3aa730a4a0fe6cd4a66e433dff648c.svg";
export { ForwardRef as ReactComponent };